import styled from '@emotion/styled'
import Link from '@mui/material/Link'
import StyledP from 'shared/components/StyledP'
import { fontFamily, fontSize } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

export const StyledDisplay3 = styled(StyledP)`
    color: #1a1a1a;
    font-style: normal;
    font-weight: 600;
    line-height: ${getPxAsRem(22)};
`
export const StyledLink = styled(Link)`
    font-size: ${fontSize.small};
    font-family: ${fontFamily.primary};
    color: ${({ theme }) => theme.palette.primary.main} !important;
    text-decoration: none;
    display: inline;
`
